export default [
  {
    title: 'Estúdios',
    route: 'audiovisual-studiosgroup',
    icon: "HeadphonesIcon",
    roles: ['permission.studiogroup.view']
  }]